/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import { sanitizeHtml } from "../utils/sanitize";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import { useClientUserTerms } from "../lib/react-query/useClientUserTerms";
import LoadingIndicator from "../components/LoadingIndicator";
import Text from "../components/ui/Text";
import useWidgetCallbackParams from "../hooks/useWidgetCallbackParams";
import { ROUTES } from "../constants/constants";

const TermsAndConditions = () => {
  const { data: userTerms, isLoading } = useClientUserTerms();
  const { clearParams } = useWidgetCallbackParams();

  useEffect(() => {
    clearParams();
  }, [clearParams]);

  return (
    <Container>
      <NavigationHeader
        title="Terms and Conditions"
        back={ROUTES.HOME}
      />
      {isLoading && <LoadingIndicator page />}
      {userTerms && <Text color="dark" dangerouslySetInnerHTML={{ __html: sanitizeHtml(userTerms) }} />}
    </Container>
  );
};

export default TermsAndConditions;
